export default "__VITE_ASSET__63f95843__"